export const ORGANISATION = {
  UGLE: 1,
  SGC: 2,
} as const;

export type Organisation = (typeof ORGANISATION)[keyof typeof ORGANISATION];

export type OrganisationDetail = {
  shortName: string;
  fullName: string;
  unitSingular: string;
  unitPlural: string;
  /** The rule under which a member's membership ceases for non-payment. */
  cessationRule: string;
  color: 'primary' | 'red-9';
};

export const ORGANISATION_DETAILS = {
  [ORGANISATION.UGLE]: {
    shortName: 'UGLE',
    fullName: 'United Grand Lodge of England',
    unitSingular: 'Lodge',
    unitPlural: 'Lodges',
    cessationRule: 'Rule 148',
    color: 'primary',
  },
  [ORGANISATION.SGC]: {
    shortName: 'SGC',
    fullName: 'Supreme Grand Chapter',
    unitSingular: 'Chapter',
    unitPlural: 'Chapters',
    cessationRule: 'Reg 71',
    color: 'red-9',
  },
} as const satisfies Record<Organisation, OrganisationDetail>;

export function resolveOrganisation(
  value: number | string | null | undefined,
): OrganisationDetail | null {
  if (value == null) return null;
  return ORGANISATION_DETAILS[Number(value) as Organisation] ?? null;
}
